import React from 'react';
import type { CustomCellRendererProps } from 'ag-grid-react';
import type { UserRow } from '../../types/User';
import { useRoles } from '../../hooks/useRoles';

// Display-mode chips for a user's assigned roleIds. Names resolved from the
// (active) roles cache; unknown ids fall back to `#<id>` so a stale/inactive
// assignment is still visible rather than silently dropped.
export function RolesCellRenderer({
  value,
}: CustomCellRendererProps<UserRow, number[]>) {
  const { roles } = useRoles();
  const nameById = new Map<number, string>(
    (roles ?? []).map((r) => [r.roleId, r.roleName]),
  );

  const ids = (value ?? []).slice().sort((a, b) => a - b);
  if (ids.length === 0) return <span />;

  return (
    <span className="lop-role-chips">
      {ids.map((id) => (
        <span key={id} className="lop-role-chip">
          {nameById.get(id) ?? `#${id}`}
        </span>
      ))}
    </span>
  );
}
